<template>
	<div>
		<navTitle><div class="pageTitle">我的认证</div></navTitle>
		<div class="certificationList">
			<div @click="toApply" class="certificationItem flex flex-align-center">
				<img src="@/static/images/index/certImg1.png" class="certImg" />
				<div class="right flex flex-align-center">
					<div class="flex-1">会员认证</div>
					<div v-if="vip.status == 0 && vip.is_pay == 1" class="idf-ing">审核中</div>
					<div v-else-if="vip.status == 1" class="idf-yes">已认证</div>
					<div v-else-if="vip.status == 2" class="idf-no">认证失败</div>
					<div v-else class="idf-no">未认证</div>
					<img src="@/static/images/icon-arrowRight.png" class="arrow" />
				</div>
			</div>
			
			
			<div class="certificationItem flex flex-align-center" @click="toCheck1">
				<img src="@/static/images/index/certImg2.png" class="certImg" />
				<div class="right flex flex-align-center">
					<div class="flex-1">名师认证</div>
					<div :class="{'idf-no':[-1, 0].includes(is_teacher_certification) , 'idf-ing': is_teacher_certification == 2, 'idf-yes': is_teacher_certification == 1}">{{ is_teacher_certification | status}}</div>
					<img src="@/static/images/icon-arrowRight.png" class="arrow" />
				</div>
			</div>
			
			<div class="certificationItem flex flex-align-center" @click="toCheck2">
				<img src="@/static/images/index/certImg3.png" class="certImg" />
				<div class="right flex flex-align-center">
					<div class="flex-1">考官认证</div>
					<div :class="{'idf-no':[-1, 0].includes(is_examiner_certification) , 'idf-ing': is_examiner_certification == 2, 'idf-yes': is_examiner_certification == 1}">{{ is_examiner_certification | status}}</div>
					<img src="@/static/images/icon-arrowRight.png" class="arrow" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
/* eslint-disable */
export default {
	watch: {},
	data() {
		return {
			is_vip: null,
			vip: {},
			is_teacher_certification: null, // 教师认证
			is_examiner_certification: null, // 考官认证

		};
	},
	filters: {
		status(val) {
			let text = ''
			switch (val*1) {
				case -1: 
					text = '认证失败'
					break
				case 0:
					text = '未认证'
					break
				case 1:
					text = '已认证'
					break
				case 2:
					text = '认证中'
					break
			}
			return text
		}
	},
	created() {
		this.getData()
	},
	mounted() {
		this.$wx.ready(() => {
      this.$wx.updateAppMessageShareData({
        title: '福建省民族管弦乐学会',
        desc: '我的认证',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
      this.$wx.updateTimelineShareData({
        title: '福建省民族管弦乐学会',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
    });
	},
	methods: {
		getData() {
			this.$get('api/user/userInfo').then(res => {
				let result = res.data
				this.is_vip = result.is_vip
				if (!Array.isArray(result.vip)) {
					this.vip = result.vip || {}
				}
				this.is_teacher_certification = result.is_teacher_certification
				this.is_examiner_certification = result.is_examiner_certification
			})
		},
		toApply() {
			let Mobile = localStorage.getItem('mobile')
			if (!Mobile) {
				this.$router.push('/login/loginPhone')
				return
			}
			if (this.vip.status == 1) {
				this.$router.push(`/my/certification/card1`)
			} else {
				this.$router.push(`/my/apply`)
			}
		},
		toCheck1() {
			let Mobile = localStorage.getItem('mobile')
			if (!Mobile) {
				this.$router.push('/login/loginPhone')
				return
			}
			if (this.vip.status != 1) {
				this.$toast('请先通过会员审核')
				return
			}
			if (this.is_teacher_certification == 1) {
				this.$router.push(`/my/certification/card2`)
			} else {
				this.$router.push({'name': 'certification_teacher', 'query': {status: this.is_teacher_certification}})
			}
		},
		toCheck2() {
			let Mobile = localStorage.getItem('mobile')
			if (!Mobile) {
				this.$router.push('/login/loginPhone')
				return
			}
			if (this.vip.status != 1) {
				this.$toast('请先通过会员审核')
				return
			}
			this.$router.push({'name': 'certification_examiner', 'query': {status: this.is_examiner_certification}})
		}
	}
};
</script>

<style scoped lang="stylus">
.certificationList
	padding 0 30px
	.certificationItem
		.certImg
			width 72px
			height 72px
			margin-right 26px
		.right
			width 100%
			padding 50px 0
			font-size 26px
			color #000000
			border-bottom 2px solid #E3E3E3
			.idf-yes
				width 112px
				height 40px
				line-height 42px
				text-align center
				border 2px solid #42B412
				border-radius 26px
				font-size 24px
				color #42B412
				margin-right 30px
			.idf-no
				width 112px
				height 40px
				line-height 42px
				text-align center
				border 2px solid #DE113C
				border-radius 26px
				font-size 24px
				color #DE113C
				margin-right 30px
			.idf-ing
				width 112px
				height 40px
				line-height 42px
				text-align center
				border 2px solid #B1B1B1
				border-radius 26px
				font-size 24px
				color #B1B1B1
				margin-right 30px
			.arrow
				width 14px
				height 26px
</style>
